<template>
  <div class="mx-auto">
    <v-card>
      <v-card-text class="black--text">
        <v-container class="mx-2">
          <template v-if="!isEdit">
            <h3>Pilih Sekolah</h3>
            <v-alert class="my-2" color="blue" text>
              <v-row>
                <v-col class="grow">
                  <div class="black--text">
                    Silakan pilih sekolah yang ingin Anda laporkan <b>pelaksanaan IHT</b>-nya melalui tombol berikut
                  </div>
                </v-col>
                <v-col class="shrink">
                  <v-btn class="success" depressed @click="onPilihSekolah">
                    <v-icon left>mdi-hospital-building</v-icon>
                    Pilih Sekolah
                  </v-btn>
                </v-col>
              </v-row>
            </v-alert>
          </template>
          <template v-if="Object.keys(sekolah).length">
            <v-row>
              <v-col cols="12" md="4" sm="12">
                <v-list-item>
                  <v-list-item-avatar color="blue">
                    <v-icon dark>mdi-hospital-building</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <div class="blue--text body-1">{{ $getDeepObj(sekolah, 'nama') || '-' }}</div>
                    <div class="black--text">NPSN: {{ $getDeepObj(sekolah, 'npsn') || '-' }}</div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col v-if="isEdit" cols="12" md="4" sm="12">
                <div class="label--text">Nama Kepala Sekolah</div>
                <div>
                  {{ $getDeepObj(monev, 'psp_diklat_sekolah.data.ptk_kasek.data.nama') || '-' }}
                </div>
              </v-col>
              <v-col cols="12" md="4" sm="12">
                <div class="label--text">Alamat</div>
                <div>{{ $getDeepObj(sekolah, 'alamat') || '-' }}</div>
              </v-col>
            </v-row>

            <v-divider class="my-5"></v-divider>

            <base-form-generator v-model="form" :schema="schema" />

            <div>
              <div class="body-1">Rekapitulasi instrumen evaluasi penyelenggaraan IHT</div>
              <div class="body-2 grey--text">Isilah instrumen berikut berdasarkan pelaksanaan kegiatan</div>
              <template v-for="(rekap, r) in mRekap">
                <div class="container my-3" :key="r">
                  <div class="body-1 black--text font-weight-bold">{{ rekap.label }}</div>
                  <v-card outlined>
                    <v-card-text>
                      <div v-for="(child, c) in rekap.children" :key="c">
                        <div class="primary--text body-1 font-weight-bold">{{ `${child.label}` }}</div>
                        <v-row class="my-2 black--text" v-for="(item, i) in Object.keys(child.items)" :key="item">
                          <v-col cols="12" sm="12" md="5">
                            {{ `${i + 1}. ${child.items[item]}` }}
                          </v-col>
                          <v-col cols="12" sm="12" md="7" class="pa-0">
                            <div class="radio-outline">
                              <template v-for="(nilai, i) in nInstrumen">
                                <span class="px-1" :key="i">
                                  <input
                                    type="radio"
                                    :id="`${nilai.value}_${item}`"
                                    v-model="feedback[item]"
                                    :value="`${nilai.value}`"
                                    checked
                                  />
                                  <label :for="`${nilai.value}_${item}`">{{ nilai.text }}</label>
                                </span>
                              </template>
                            </div>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-divider />
                          </v-col>
                        </v-row>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </template>
            </div>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <div class="body-1 black--text font-weight-bold mx-3">C. Hambatan dan dukungan</div>
              </v-col>
              <template v-for="(child, idChild) in mFeedback">
                <v-col :key="idChild" cols="12" sm="12" :md="child.grid || 12">
                  <div class="pt-3 px-3">
                    <span v-html="child.label" />
                  </div>
                  <template v-for="(ins, i) in child.instrumen">
                    <div :key="i" v-if="ins.type === 'Checkbox'">
                      <v-checkbox
                        v-model="instrument[ins.name]"
                        :label="ins.label"
                        :value="ins.value"
                        :disabled="
                          (instrument['opsi-psp_7_8'] && ins.name !== 'opsi-psp_7_8' && idChild === 0) ||
                            (instrument['opsi-psp_8_13'] && ins.name !== 'opsi-psp_8_13' && idChild === 1)
                        "
                        class="mx-2 my-1"
                        hide-details
                        @change="onChangeOpsi(child, ins.name)"
                      />
                    </div>
                  </template>
                  <div
                    class="mx-3"
                    v-show="
                      (instrument['opsi-psp_7_9'] && idChild === 0) || (instrument['opsi-psp_8_14'] && idChild === 1)
                    "
                  >
                    <v-text-field
                      v-model="instrument[`${idChild === 0 ? 'opsi-psp_7_9' : 'opsi-psp_8_14'}_catatan`]"
                      placeholder="Tuliskan keterangan lainnya"
                      class="pt-0"
                    ></v-text-field>
                  </div>
                </v-col>
              </template>
            </v-row>
          </template>
        </v-container>
      </v-card-text>
    </v-card>
    <base-list-popup
      ref="kandidat"
      :id="''"
      api="diklatUpt/getKandidat"
      disable="psp_monev_dinases"
      labelDisable="Sudah ditambahkan oleh petugas lain"
      title="Pilih Sekolah"
    ></base-list-popup>
  </div>
</template>
<script>
import BaseFormGenerator from '../../../../components/base/BaseFormGenerator';
import BaseListPopup from '../../../../components/base/BaseListPopup';
export default {
  components: { BaseListPopup, BaseFormGenerator },
  props: {
    initValue: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      form: {},
      feedback: {},
      instrument: {},
      sekolah: {},
      nInstrumen: [
        { value: 1, text: 'Sangat tidak Setuju' },
        { value: 2, text: 'Tidak Setuju' },
        { value: 3, text: 'Setuju' },
        { value: 4, text: 'Sangat Setuju' },
      ],
      isEdit: false,
      id: null,
      monev: {},
    };
  },
  computed: {
    schema() {
      return [
        {
          type: 'VDatePicker',
          name: 'tgl_monev',
          label: 'Tanggal Pelaksanaan',
          labelColor: 'info',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 4, sm: 12 },
          outlined: true,
          required: true,
          dense: true,
          singleLine: true,
        },
      ];
    },

    mRekap() {
      return [
        {
          label: 'A. Instrumen Umpan Balik Pengajar IHT',
          children: [
            {
              label: 'Persepsi Terkait Metode IHT',
              items: {
                101: 'Penyampaian materi yang diberikan menarik',
                102: 'Pengajar menguasai materi IHT',
                103: 'Pengajar mampu menyampaikan materi sehingga mudah dipahami.',
                104: 'Pengajar memberikan umpan balik (feedback) yang membantu peserta untuk lebih memahami materi yang diajarkan',
                105: 'Pengajar memberikan kesempatan bertanya dan berdiskusi.',
                106: 'Pengajar melakukan asesmen yang dilakukan oleh pengajar sesuai dengan tujuan IHT',
                107: 'Pengajar memiliki manajemen waktu pembelajaran yang baik',
                108: 'Pengajar mampu menjawab pertanyaan-pertanyaan yang diajukan oleh peserta IHT',
                109: 'Pengajar mampu memberikan motivasi kepada peserta IHT',
              },
            },
          ],
        },
        {
          label: 'B. Instrumen Umpan Balik Proses Penyelenggaraan IHT',
          children: [
            {
              label: 'Persepsi terkait Metode IHT',
              items: {
                110: 'Metode kombinasi antara synchronous (terstruktur) dan asynchronous (mandiri) dapat secara efektif meningkatkan pemahaman dan keterampilan.',
                111: 'Secara umum, durasi pelaksanaan IHT dengan metode terstruktur (synchronous) efisien.',
                112: 'Secara umum, durasi pelaksanaan IHT dengan metode mandiri (asynchronous) efisien.',
                113: 'Selama pelaksanaan IHT, terjadi interaksi antar peserta untuk meningkatkan keterampilan dan pengetahuan.',
                114: 'Keterampilan yang diperoleh selama pelaksanaan IHT relevan dengan tugas saya sebagai pelaksana program di satuan pendidikan',
                115: 'Kegiatan praktik dalam pelaksanaan IHT memiliki kesesuaian dengan konsep/teori yang diajarkan.',
                116: 'Teknik penyampaian materi melalui eksplorasi konsep yang dilanjutkan dengan diskusi (pembelajaran alur merdeka) memudahkan saya dalam memahami materi IHT',
              },
            },
            {
              label: 'Perangkat Ajar IHT',
              items: {
                117: 'Panduan IHT yang diberikan berisi informasi yang dibutuhkan oleh peserta',
                118: 'Modul IHT mudah untuk diakses/diunduh.',
                119: 'Modul memudahkan saya dalam memahami materi IHT',
                120: 'Platform pembelajaran yang digunakan untuk proses IHT mudah untuk digunakan (user friendly).',
                121: 'Platform pembelajaran IHT membantu saya memahami materi.',
                122: 'Platform pembelajaran IHT membantu saya mengikuti keseluruhan proses IHT.',
                123: 'Platform pembelajaran IHT memberikan informasi tentang umpan balik (feedback) dari pengajar sehingga membantu meningkatkan pengetahuan dan keterampilan saya.',
              },
            },
            {
              label: 'Substansi/Materi IHT',
              items: {
                124: 'Secara umum, materi IHT cukup mudah dipahami',
                125: 'Materi IHT menyiapkan saya dalam meningkatkan kualitas pembelajaran kepada peserta didik',
                126: 'Materi IHT dapat menjawab permasalahan di tingkat satuan pendidikan',
              },
            },
          ],
        },
      ];
    },

    mFeedback() {
      return [
        {
          grid: 6,
          label:
            'Jenis Hambatan apa yang paling sering ditemui peserta pelatihan selama proses IHT? <i>(jawaban boleh lebih dari satu)</i>',
          instrumen: [
            {
              id: '1',
              type: 'Checkbox',
              name: 'opsi-psp_7_1',
              value: 1,
              trueValue: 1,
              falseValue: '',
              label: 'Tidak memiliki cukup waktu untuk mengikuti IHT',
              labelColor: 'black',
              hint: 'wajib diisi',
              hideDetails: true,
              class: ['mt-0', 'pt-1', 'pb-0'],
              grid: { cols: 12 },
            },
            {
              id: '2',
              type: 'Checkbox',
              name: 'opsi-psp_7_2',
              value: 2,
              trueValue: 2,
              falseValue: '',
              label: 'Tidak memiliki perangkat yang memadai',
              labelColor: 'black',
              hint: 'wajib diisi',
              hideDetails: true,
              class: ['mt-0', 'pt-1', 'pb-0'],
              grid: { cols: 12 },
            },
            {
              id: '3',
              type: 'Checkbox',
              name: 'opsi-psp_7_3',
              value: 3,
              trueValue: 3,
              falseValue: '',
              label: 'Berada di wilayah yang memiliki jaringan internet kurang memadai ',
              labelColor: 'black',
              hint: 'wajib diisi',
              hideDetails: true,
              class: ['mt-0', 'pt-1', 'pb-0'],
              grid: { cols: 12 },
            },
            {
              type: 'Checkbox',
              name: 'opsi-psp_7_4',
              value: 4,
              trueValue: 4,
              falseValue: '',
              label: 'Berada di wilayah yang memiliki jaringan listrik kurang memadai',
              labelColor: 'black',
              hint: 'wajib diisi',
              hideDetails: true,
              class: ['mt-0', 'pt-1', 'pb-0'],
              grid: { cols: 12 },
            },
            {
              type: 'Checkbox',
              name: 'opsi-psp_7_5',
              value: 5,
              trueValue: 5,
              falseValue: '',
              label: 'Kesulitan dalam menggunakan platform belajar',
              labelColor: 'black',
              hint: 'wajib diisi',
              hideDetails: true,
              class: ['mt-0', 'pt-1', 'pb-0'],
              grid: { cols: 12 },
            },
            {
              type: 'Checkbox',
              name: 'opsi-psp_7_6',
              value: 6,
              trueValue: 6,
              falseValue: '',
              label: 'Tidak mendapat dukungan lingkungan tempat saya bertugas untuk mengikuti proses IHT',
              labelColor: 'black',
              hint: 'wajib diisi',
              hideDetails: true,
              class: ['mt-0', 'pt-1', 'pb-0'],
              grid: { cols: 12 },
            },
            {
              type: 'Checkbox',
              name: 'opsi-psp_7_7',
              value: 7,
              trueValue: 7,
              falseValue: '',
              label: 'Tidak mendapat dukungan dari keluarga untuk mengikuti proses IHT',
              labelColor: 'black',
              hint: 'wajib diisi',
              hideDetails: true,
              class: ['mt-0', 'pt-1', 'pb-0'],
              grid: { cols: 12 },
            },
            {
              type: 'Checkbox',
              name: 'opsi-psp_7_8',
              value: 8,
              trueValue: 8,
              falseValue: '',
              label: 'Tidak ada',
              labelColor: 'black',
              hint: 'wajib diisi',
              hideDetails: true,
              class: ['mt-0', 'pt-1', 'pb-0'],
              grid: { cols: 12 },
            },
            {
              type: 'Checkbox',
              name: 'opsi-psp_7_9',
              value: 9,
              trueValue: 9,
              falseValue: '',
              label: 'Lainnya',
              labelColor: 'black',
              hint: 'wajib diisi',
              hideDetails: true,
              class: ['mt-0', 'pt-1'],
              grid: { cols: 12 },
            },
          ],
        },
        {
          grid: 6,
          label:
            'Jenis Dukungan yang paling banyak diperlukan oleh peserta IHT agar proses IHT semakin baik? <i>(jawaban boleh lebih dari satu)</i>',
          instrumen: [
            {
              type: 'Checkbox',
              name: 'opsi-psp_8_10',
              value: 10,
              trueValue: 10,
              falseValue: '',
              label:
                'Penambahan durasi pelaksanaan IHT  untuk meningkatkan pengetahuan dan keterampilan sebagai guru/ pemimpin pembelajaran di dalam kelas',
              labelColor: 'black',
              hint: 'wajib diisi',
              hideDetails: true,
              class: ['mt-0', 'pt-1', 'pb-0'],
              grid: { cols: 12 },
            },
            {
              type: 'Checkbox',
              name: 'opsi-psp_8_11',
              value: 11,
              trueValue: 11,
              falseValue: '',
              label: 'Pengenalan platform pembelajaran yang akan digunakan',
              labelColor: 'black',
              hint: 'wajib diisi',
              hideDetails: true,
              class: ['mt-0', 'pt-1', 'pb-0'],
              grid: { cols: 12 },
            },
            {
              type: 'Checkbox',
              name: 'opsi-psp_8_12',
              value: 12,
              trueValue: 12,
              falseValue: '',
              label: 'Sarana dan prasarana pelaksanaan IHT',
              labelColor: 'black',
              hint: 'wajib diisi',
              hideDetails: true,
              class: ['mt-0', 'pt-1', 'pb-0'],
              grid: { cols: 12 },
            },
            {
              type: 'Checkbox',
              name: 'opsi-psp_8_13',
              value: 13,
              trueValue: 13,
              falseValue: '',
              label: 'Tidak ada',
              labelColor: 'black',
              hint: 'wajib diisi',
              hideDetails: true,
              class: ['mt-0', 'pt-1', 'pb-0'],
              grid: { cols: 12 },
            },
            {
              type: 'Checkbox',
              name: 'opsi-psp_8_14',
              value: 14,
              trueValue: 14,
              falseValue: '',
              label: 'Lainnya',
              labelColor: 'black',
              hint: 'wajib diisi',
              hideDetails: true,
              class: ['mt-0', 'pt-1'],
              grid: { cols: 12 },
            },
          ],
        },
      ];
    },
  },

  methods: {
    reset() {
      this.$set(this, 'form', {});
      this.$set(this, 'isEdit', false);
      this.$set(this, 'id', null);
    },

    onPilihSekolah() {
      const fields = [
        {
          key: 'nama',
          icon: 'mdi-hospital-building',
          title: '',
          list: [
            {
              key: 'nama',
              class: 'body-1 blue--text',
            },
            {
              key: 'npsn',
              label: 'NPSN: ',
              class: 'body-2 black--text font-weight-medium',
            },
            {
              key: 'alamat',
              class: 'black--text',
            },
          ],
        },
      ];

      this.$refs.kandidat.open(fields).then((data) => {
        this.sekolah = Object.assign({}, data);
      });
    },

    onChangeOpsi(child, name) {
      if (this.form[name]) {
        if (['opsi-psp_7_8', 'opsi-psp_8_13'].includes(name)) {
          for (const ins of child.instrumen || []) {
            if (ins.name !== name) {
              this.$set(this.form, ins.name, '');
            }
          }
        } else if (['opsi-psp_7_8', 'opsi-psp_8_13'].includes(name)) {
          this.$set(this.form, `${name}_catatan`, null);
        }
      }
    },

    getValue() {
      let id = 0;
      for (const key in this.instrument) {
        if (/instrumen-psp/.test(key)) {
          const instrumen = key.split('_');

          if (this.instrument[key]) {
            this.form[`instrumens[${id}][k_monev_instrumen_psp]`] = instrumen[1] || '';
            this.form[`instrumens[${id}][catatan]`] = this.instrument[key] || '';
            id += 1;
          }

          delete this.form[key];
        } else if (/opsi-psp/.test(key) && !/catatan/.test(key)) {
          const opsi = key.split('_');

          if (this.instrument[key]) {
            this.form[`instrumens[${id}][k_monev_instrumen_psp]`] = opsi[1] || '';
            this.form[`instrumens[${id}][k_monev_opsi_psp]`] = this.instrument[key] || '';
            this.form[`instrumens[${id}][catatan]`] = this.instrument[`${key}_catatan`] || '';
            id += 1;
          }

          delete this.form[key];
          delete this.form[`${key}_catatan`];
        }
      }

      id = 0;
      for (const key in this.feedback) {
        this.form[`feedbacks[${id}][k_monev_feedback_psp]`] = key;
        this.form[`feedbacks[${id}][nilai]`] = this.feedback[key];
        id++;
      }

      this.form['sekolah_id'] = this.$getDeepObj(this, 'sekolah.sekolah_id');

      return {
        id: this.id,
        params: this.form,
      };
    },

    initForm(monev) {
      let feedbacks = {};
      let instrumens = {};

      if (monev && monev.psp_monev_feedback_dinases && monev.psp_monev_feedback_dinases.data.length) {
        const obj = monev.psp_monev_feedback_dinases.data || [];
        obj.forEach((item) => {
          this.$set(feedbacks, item.k_monev_feedback_psp, item.nilai);
        });
      }

      if (monev && monev.psp_monev_instrumen_dinases && monev.psp_monev_instrumen_dinases.data.length) {
        const obj = monev.psp_monev_instrumen_dinases.data || [];
        obj.forEach((ins) => {
          if (ins.k_monev_opsi_psp) {
            this.$set(
              instrumens,
              `opsi-psp_${ins.k_monev_instrumen_psp}_${ins.k_monev_opsi_psp}`,
              ins.k_monev_opsi_psp
            );

            if ([9, 14].includes(+ins.k_monev_opsi_psp)) {
              this.$set(
                instrumens,
                `opsi-psp_${ins.k_monev_instrumen_psp}_${ins.k_monev_opsi_psp}_catatan`,
                ins.catatan || ''
              );
            }
          } else {
            this.$set(instrumens, `instrumen-psp_${ins.k_monev_instrumen_psp}`, ins.catatan || '');
          }
        });
      }

      this.$set(this, 'sekolah', this.$getDeepObj(monev, 'sekolah.data') || {});
      this.$set(this.form, 'tgl_monev', this.$getDeepObj(monev, 'tgl_monev') || '');
      this.monev = monev || {};
      this.feedback = feedbacks;
      this.instrument = instrumens;
      this.isEdit = !!monev;
      this.id = this.$getDeepObj(monev, 'psp_monev_dinas_id') || null;
    },
  },

  watch: {
    initValue: 'initForm',
  },
};
</script>
